/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import commonJobsStyles from "./commonJobsStyles";

const jobSectionStyle = {
  ...commonJobsStyles,
  job: {
    padding: "1rem",
    margin: "1rem 0",
    border: "1px solid",
    borderColor: "primary.main",
  },
  button: {
    marginLeft: "auto",
  },
};

export default jobSectionStyle;
